import { axiosInstance as axios } from "services";

export const deletePhone = async (endPoint, id, body) => {
  const { data } = await axios.post(`${endPoint}${id}`, body);
  if (!data.success) throw new Error(data.error || "Failed to delete phone");
  return data;
};

